<template>
  <div class="notice-container">
    <div class="heading-icon" style="background-color: #2a9d8f">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14,2 14,8 20,8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10,9 9,9 8,9"></polyline>
      </svg>
    </div>
    <h1 class="title-with-underline">{{ noticeTitle }}</h1>

    <div class="notice-content" @click="handleContentClick">
      <p v-if="pageTitleTextContent" class="notice-subtitle" v-html="pageTitleTextContent"></p>
      <p v-else class="notice-subtitle">攸關您的就診權益，在進行掛號前請詳細閱讀</p>

      <div v-if="data.blocks && data.blocks.length > 0">
        <div v-for="(block, index) in data.blocks" :key="index" class="notice-block">
          <template v-if="block.type !== 'pageTitle'">
          <!-- textOnly type -->
          <div v-if="block.type === 'textOnly'" class="notice-item">
            <div v-if="block.title" class="notice-item-title">{{ block.title }}</div>
            <div v-if="block.content" class="notice-item-content" v-html="block.content"></div>
          </div>

          <!-- titleAndText type -->
          <div v-else-if="block.type === 'titleAndText'" class="notice-item">
            <div v-if="block.title" class="notice-item-title notice-item-title--title-and-text">{{ block.title }}</div>
            <div
              v-if="block.content"
              class="notice-item-content notice-item-content--title-and-text"
              v-html="block.content"
            ></div>
          </div>

          <!-- singleLine type -->
          <div v-else-if="block.type === 'singleLine'" class="notice-item">
            <div class="notice-item-content" v-html="block.content"></div>
          </div>

          <!-- toggle type (accordion) -->
          <details v-else-if="block.type === 'toggle'" class="notice-item notice-accordion">
            <summary class="notice-item-title">{{ block.title }}</summary>
            <ul class="notice-list-items">
              <li v-for="(item, i) in block.items" :key="i">{{ item }}</li>
            </ul>
          </details>

          <!-- image type -->
          <div v-else-if="block.type === 'image'" class="notice-item">
            <div v-if="block.title" class="notice-item-title">{{ block.title }}</div>
            <img v-if="block.url" :src="block.url" :alt="block.title || 'Notice image'" />
            <div v-if="block.content" class="notice-item-content" v-html="block.content"></div>
          </div>

          <!-- file type -->
          <div v-else-if="block.type === 'file'" class="notice-item">
            <div v-if="block.title" class="notice-item-title notice-item-title--file">{{ block.title }}</div>
            <div
              v-if="block.content"
              class="notice-item-content notice-item-content--file"
              v-html="block.content"
            ></div>
          </div>
          </template>
        </div>
      </div>
    </div>
    <ImageLightBox ref="globalLightbox" />
  </div>
</template>

<script>
import ImageLightBox from '@/components/Page/Chatroom/ImageLightBox.vue'

export default {
  name: 'Notice',
  components: { ImageLightBox },
  props: {
    data: {
      type: Object,
      default: () => ({
        title: '',
        blocks: []
      })
    }
  },
  computed: {
    sourceType() {
      return this.$store.getters['web/tongxin/sourceType'] || 'health'
    },
    noticeTitle() {
      if (this.data && this.data.title) return this.data.title
      if (this.sourceType === 'vaccine') return '疫苗掛號須知'
      if (this.sourceType === 'outpatient') return '門診掛號須知'
      return '體檢／健檢掛號須知'
    },
    pageTitleTextContent() {
      if (!this.data || !Array.isArray(this.data.blocks)) return ''
      const pageTitleBlock = this.data.blocks.find(block => block && block.type === 'pageTitle')
      return pageTitleBlock && pageTitleBlock.content ? pageTitleBlock.content : ''
    }
  },
  methods: {
    handleContentClick(event) {
      if (event.target && event.target.tagName === 'IMG') {
        const src = event.target.src
        if (src && this.$refs.globalLightbox) {
          this.$refs.globalLightbox.show([src], 0)
        }
      }
    }
  }
}
</script>

<style scoped>
/* 須知內容區域 */
.notice-content {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
}

.notice-subtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  text-align: center;
  font-style: italic;
}

.notice-list {
  list-style: none;
  padding: 0;
}

.notice-item {
  margin-bottom: 24px;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  border-left: 4px solid #2a9d8f;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.notice-item:last-child {
  margin-bottom: 0;
}

.notice-item-content img,
.notice-item img {
  cursor: pointer;
}

.notice-item-title {
  font-size: 24px;
  font-weight: bold;
  color: #207868;
  margin-bottom: 8px;
  line-height: 1.4;
}

.notice-item-content {
  font-size: 20px;
  color: #555;
  line-height: 1.6;
}

.notice-item-title--title-and-text {
  font-size: 24px;
}

.notice-item-content--title-and-text {
  font-size: 20px;
}

.notice-item-title--file {
  font-size: 24px;
}

.notice-item-content--file {
  font-size: 20px;
}

.highlight-text {
  color: #207868;
  font-weight: bold;
}

@media screen and (max-width: 768px) {
  .notice-content {
    padding: 16px;
  }

  .notice-item {
    padding: 12px;
    margin-bottom: 16px;
  }

  .notice-subtitle {
    font-size: 16px;
  }
}

/* Notice block */
.notice-block {
  margin-bottom: 16px;
}

/* Accordion */
.notice-accordion {
  margin-bottom: 16px;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  border-left: 4px solid #2a9d8f;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.notice-accordion summary {
  font-size: 24px;
  font-weight: bold;
  color: #207868;
  cursor: pointer;
  margin-bottom: 8px;
}

.notice-accordion[open] summary {
  margin-bottom: 12px;
}

.notice-list-items {
  list-style: disc;
  padding-left: 24px;
  margin: 8px 0;
}

.notice-list-items li {
  font-size: 20px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 8px;
}

/* Image */
.notice-image {
  margin: 16px 0;
  text-align: center;
}

.notice-image img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
</style>
